import { render, staticRenderFns } from "./GCard.vue?vue&type=template&id=63dfbbec&scoped=true"
import script from "./GCard.vue?vue&type=script&lang=js"
export * from "./GCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfbbec",
  null
  
)

export default component.exports